import React from 'react'
import Link from 'next/link'
import { Title, BodyWrapper, ButtonWrapper } from './Customize.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import { Article } from 'components/Sections/Article'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'

export const Customize: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Article background="primary">
      <Title id="customize-title">{t('raw-benefits:customize.title')}</Title>

      <BodyWrapper>
        <Text>
          <Trans
            i18nKey="raw-benefits:customize.body.0"
            components={{
              FrozenLink: <Link href="/recipes" />,
              FreezeDriedLink: <Link href="https://try.wefeedraw.com/products-freeze-dried" />,
            }}
          />
        </Text>
        <Text>
          <Trans
            i18nKey="raw-benefits:customize.body.1"
            components={{ MealPlanLink: <Link href="/meal-plan" /> }}
          />
        </Text>
      </BodyWrapper>

      <ButtonWrapper>
        <Link href="/meal-plan" passHref>
          <Button as="a" className="cta" variant="primary">
            {t('raw-benefits:customize.primary-cta')}
          </Button>
        </Link>
      </ButtonWrapper>
    </Article>
  )
}

Customize.displayName = 'Customize'
